import { v4 as uuidv4 } from "uuid";

export default {
  prettyTimeStamp(ts) {
    let sec = (Date.now() - ts) / 1000;
    if (sec < 60) return "Just now";
    let min = sec / 60;
    if (min < 60) return Math.floor(min) + " min ago";
    let h = min / 60;
    if (Math.floor(h) == 1) return "1 hour ago";
    if (h < 24) return Math.floor(h) + " hours ago";
    let days = h / 24;
    if (Math.floor(days) == 1) return "1 day ago";
    if (days < 30) return Math.floor(days) + " days ago";
    let months = days / 30;
    if (Math.floor(months) == 1) return "1 mounth ago";
    if (months < 12) return Math.floor(months) + " months ago";
    let years = months / 12;
    if (Math.floor(years) == 1) return "1 year ago";
    return Math.floor(years) + " years ago";
  },

  timeStampToTime(ts) {
    var a = new Date(ts);
    var hour = a.getHours() - 1; // GMT+1
    var min = a.getMinutes();
    var sec = a.getSeconds() + 1; // To end on a full second
    var time = sec + "s";
    if (min > 0) time = min + "m" + time;
    if (hour > 0) time = hour + "h " + time;

    return time;
  },

  timeStampToDate(ts) {
    var a = new Date(ts);
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var hour = a.getHours();
    var min = a.getMinutes();
    var sec = a.getSeconds();
    var time =
      date + " " + month + " " + year + " " + hour + ":" + min + ":" + sec;
    return time;
  },

  timeStampToHourAndMinute(ts) {
    var a = new Date(ts);
    var hour = a.getHours();
    var min = a.getMinutes();
    if (min < 10) min = "0" + min;
    if (hour < 10) hour = "0" + hour;
    var time = hour + "h" + min;
    return time;
  },

  prettyNumber(x) {
    if (x === null) return null;
    if (typeof x !== "number") return x;
    if (Math.abs(x) < 1000000) {
      return Number.isInteger(x) ? x : x.toFixed(2);
    }

    return x.toPrecision(3);
  },

  uuid() {
    return uuidv4();
  },

  getTimestamp() {
    return Date.now();
  },

  getDate() {
    return this.timeStampToDate(this.getTimestamp());
  },
};
